import React, { useEffect, useMemo, useRef, useState }  from 'react'
import './map.css'

import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api"

const MapWrapper = () => {
  const center = useMemo(() => ({ lat: -1.177618, lng: 36.710386 }, []));
  return (
    <GoogleMap zoom={15 } center={{ lat: -1.177618, lng: 36.710386 }} mapContainerClassName="map_wrapper" >
      <Marker position={{ lat: -1.177618, lng: 36.710386 }} />
    </GoogleMap>
  )
}

function Map() {
  const { isLoaded } = useLoadScript({ googleMapsApiKey: "AIzaSyC-izJWjjI0o3W2b7CG2QjpBVq4nrQ_IMI" });

  if(!isLoaded) return <div>Loading...</div>

  return (
    <MapWrapper />
  )
}

export default Map